



































import moment from 'moment';
import Vue, { PropType } from 'vue';

export default Vue.extend({
  props: {
    size: {
      type: Number,
    },
    meterStatus: {
      type: String as PropType<string | null>,
      default: null,
    },
    breakerStatus: {
      type: String as PropType<string | null>,
      default: null,
    },
    isSimpl: {
      type: Boolean,
      default: false,
    },
    vendorMissingSince: {
      type: String as PropType<string | null>,
      default: null,
    },
  },
  computed: {
    vendorMissingDate(): string {
      return this.vendorMissingSince ? moment(this.vendorMissingSince).format('DD-MM-YYYY') : '';
    },
  },
});
